import { useState, useEffect } from "react";
import { useParams, useLocation } from "react-router-dom";
import camisas from "../data/camisas";
import CardCamisa from "../components/CardCamisa/CardCamisa";
import ModalCamisa from "../components/ModalCamisa/ModalCamisa";

export default function Time() {
  const { pais, liga, time } = useParams();
  const location = useLocation();
  const [camisaSelecionada, setCamisaSelecionada] = useState(null);

  useEffect(() => {
    setCamisaSelecionada(null);
  }, [location.pathname]);

  const camisasDoTime = camisas.filter(
    (c) => c.pais === pais && c.liga === liga && c.time === time
  );

  const masculinas = camisasDoTime.filter(
    (c) =>
      c.tipo === "masculino" && !c.edicaoEspecial && c.categoria === "oficial"
  );

  const jaquetas = camisasDoTime.filter(
    (c) => c.categoria === "jaqueta" && !c.edicaoEspecial
  );

  const blusas = camisasDoTime.filter(
    (c) => c.categoria === "blusa" && !c.edicaoEspecial
  );

  const regatas = camisasDoTime.filter(
    (c) => c.categoria === "regata" && !c.edicaoEspecial
  );

  const edicaoEspecial = camisasDoTime.filter((c) => c.edicaoEspecial);

  const femininas = camisasDoTime.filter(
    (c) => c.tipo === "feminino" && !c.edicaoEspecial
  );

  const renderGrid = (lista) => (
    <div className="grid">
      {lista.map((camisa) => (
        <CardCamisa
          key={`${camisa.time}-${camisa.id}`}
          camisa={camisa}
          onClick={setCamisaSelecionada}
        />
      ))}
    </div>
  );

  return (
    <div className="container">
      <h1 className="page-title">{time.replaceAll("-", " ")}</h1>

      {masculinas.length > 0 && (
        <>
          <h2 className="section-title">Camisas Masculinas</h2>
          {renderGrid(masculinas)}
        </>
      )}

      {edicaoEspecial.length > 0 && (
        <>
          <h2 className="section-title">Edição Especial</h2>
          {renderGrid(edicaoEspecial)}
        </>
      )}

      {jaquetas.length > 0 && (
        <>
          <h2 className="section-title">
            {jaquetas.length === 1 ? "Jaqueta" : "Jaquetas"}
          </h2>
          {renderGrid(jaquetas)}
        </>
      )}

      {blusas.length > 0 && (
        <>
          <h2 className="section-title">
            {blusas.length === 1 ? "Blusa" : "Blusas"}
          </h2>
          {renderGrid(blusas)}
        </>
      )}
      {regatas.length > 0 && (
        <>
          <h2 className="section-title">
            {" "}
            {regatas.length === 1 ? "Regata" : "Regatas"}
          </h2>
          {renderGrid(regatas)}
        </>
      )}

      {femininas.length > 0 && (
        <>
          <h2 className="section-title">Camisas Femininas</h2>
          {renderGrid(femininas)}
        </>
      )}

      {camisaSelecionada && (
        <ModalCamisa
          camisa={camisaSelecionada}
          onClose={() => setCamisaSelecionada(null)}
        />
      )}
    </div>
  );
}
